jQuery($ => {
  class Filter {
    constructor(element) {
      this._        = element;
      this._element = $(element);
      this._form    = this._element.find('.m-filter__form');
      this._input   = this._form.find('input[type="text"]');
      this._search  = this._form.find('.m-search');
      this._feedId  = this._form.attr('aria-controls');
      this._feed    = $(`#${this._feedId}`);
      this._apply   = this._element.find('.m-filter__apply');
      this._clear   = this._element.find('.m-filter__clear');
      this._ajax    = this._element.data('ajax');

      this.init();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Initialize
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    init() {
      this.setupHandlers();
      this._element.trigger('init', this);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup Handlers
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setupHandlers() {
      this._apply.on('click', this.handleApplyFilters);
      this._clear.on('click', this.handleClearFilters);
      this._form.on('change', this.handleApplyFilters);
      this._input.on('keyup', this.handleApplyFilters);
      this._search.on('clear', this.handleApplyFilters);

      // window.onpopstate = (event) => {
      //   if (event.state && event.state.filters) {
      //     this.handleFormFields(new URLSearchParams(event.state.filters));
      //     this.handleApplyFilters(null, false);
      //   }
      // };
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Apply Filters
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleApplyFilters = (event, pushState = true) => {
      if (event) event.preventDefault();

      let data = {
        action: 'ug_filter_posts',
        data: this._form.serialize()
      }

      // if (pushState) {
      //   const formData = new FormData(this._form[0]);
      //   const params = new URLSearchParams();

      //   for (let [key, value] of formData.entries()) {
      //     if (value && !this._form.find(`[name="${key}"]`).is(':hidden')) {
      //       params.append(key, value);
      //     }
      //   }

      //   const url = new URL(window.location);
      //   url.search = params.toString();
      //   window.history.pushState({ filters: params.toString() }, '', url);
      // }

      $.ajax({
        url: this._ajax,
        type: 'POST',
        data,
        success: this.handleResponse
      });
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Clear Filters
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleClearFilters = (event) => {
      event.preventDefault();

      this._form.form('handleReset');

      let data = {
        action: 'ug_reset_posts',
        data: this._form.serialize()
      }

      const url = new URL(window.location);
      url.search = '';
      window.history.pushState({ filters: '' }, '', url);

      $.ajax({
        url: this._ajax,
        type: 'POST',
        data,
        success: this.handleResponse
      });
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Response
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleResponse = response => {
      const isSuccess = response.success === undefined || response.success;
      const data      = response.data || {};

      if (isSuccess) {
        this.handleRequestSuccess(data);
      } else {
        this.handleRequestError(data);
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Request Success
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleRequestSuccess = response => {
      this._feed.html(response);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Request Error
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleRequestError = response => {
      console.error('Status: Filter ajax request failed', response);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Form Fields
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleFormFields = (params) => {
      this._form[0].reset();

      for (const [key, value] of params.entries()) {
        const $fields = this._form.find(`[name="${key}"]`);

        $fields.each((index, field) => {
          const $field = $(field);
          if ($field.attr('type') === 'checkbox') {
            $field.prop('checked', value === $field.val());
          } else if ($field.attr('type') === 'radio') {
            $field.filter(`[value="${value}"]`).prop('checked', true);
          } else {
            $field.val(value);
          }
        });
      }
    }
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Setup jQuery Plugin
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $.fn.filterHandling = function() {
    var _ = this,
        opt = arguments[0],
        args = Array.prototype.slice.call(arguments, 1),
        l = _.length,
        i,
        ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined')
        _[i].filterHandling = new Filter(_[i], opt);
      else
        ret = _[i].filterHandling[opt].apply(_[i].filterHandling, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Run
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('.m-filter').filterHandling();
});